import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { concatMap, map, catchError, of } from "rxjs";
import { CompanyClient } from "src/api-service";
import { CompaniesActions } from "./companies.actions";
import { normalizeError } from "../../../../app-store-error.types";

@Injectable()
export class CompaniesEffects {
    private readonly actions$ = inject(Actions);
    private readonly companyClient = inject(CompanyClient);

    load$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CompaniesActions.load),
            concatMap(() =>
                this.companyClient.getAll().pipe(
                    map(companies => CompaniesActions.loadSuccess({ companies })),
                    catchError(error =>
                        of(
                            CompaniesActions.loadFailure({
                                error: normalizeError(error),
                                toastKey: "ADMIN_PANEL.EDIT_COMPANY_SECTIONS.TOAST.LOAD_ERROR",
                            }),
                        ),
                    ),
                ),
            ),
        ),
    );

    createCompany$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CompaniesActions.createCompany),
            concatMap(({ request }) =>
                this.companyClient.create(request).pipe(
                    concatMap(() => [
                        CompaniesActions.createCompanySuccess({
                            toastKey: "ADMIN_PANEL.EDIT_COMPANY_SECTIONS.TOAST.CREATE_SUCCESS",
                        }),
                        CompaniesActions.load(),
                    ]),
                    catchError(error =>
                        of(
                            CompaniesActions.createCompanyFailure({
                                error: normalizeError(error),
                                toastKey: "ADMIN_PANEL.EDIT_COMPANY_SECTIONS.TOAST.CREATE_ERROR",
                            }),
                        ),
                    ),
                ),
            ),
        ),
    );

    updateCompany$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CompaniesActions.updateCompany),
            concatMap(({ request, id }) =>
                this.companyClient.patch(id, request).pipe(
                    concatMap(() => [
                        CompaniesActions.updateCompanySuccess({
                            toastKey: "ADMIN_PANEL.EDIT_COMPANY_SECTIONS.TOAST.UPDATE_SUCCESS",
                        }),
                        CompaniesActions.load(),
                    ]),
                    catchError(error =>
                        of(
                            CompaniesActions.updateCompanyFailure({
                                error: normalizeError(error),
                                toastKey: "ADMIN_PANEL.EDIT_COMPANY_SECTIONS.TOAST.UPDATE_ERROR",
                            }),
                        ),
                    ),
                ),
            ),
        ),
    );
}
